/* -----------------Globals--------------- */
import MaterialCommunityIcons from "@react-native-vector-icons/material-design-icons/static";

/* -----------------UI--------------- */
import { Divider, List } from "react-native-paper";

/* -----------------Helpers & Hooks--------------- */
import { useAppTheme } from "../../useAppTheme";

/* -----------------Types--------------- */
import type { IconType } from "../../icon";

import { useDevice } from "../../useDevice";
/* -----------------Child components--------------- */
import Box from "../Box";
import { Checkbox } from "../Checkbox";

type FeedbackReasonsProps = {
	feedbackReasonList: {
		title: string;
		description: string;
		icon: IconType;
		value: string;
	}[];
	selectedReasons: string[];
	onReasonPress: (reason: string) => void;
};

export const FeedbackReasons = ({
	feedbackReasonList,
	selectedReasons,
	onReasonPress,
}: FeedbackReasonsProps) => {
	const theme = useAppTheme();
	const { isMobile } = useDevice();

	return (
		<Box paddingHorizontal={24}>
			{feedbackReasonList.map((reason, index) => {
				const checked = selectedReasons.includes(reason.value);
				return (
					<Box key={reason.value}>
						<List.Item
							style={{
								paddingVertical: 8,
								paddingLeft: isMobile ? 0 : 8,
								paddingRight: isMobile ? 0 : 8,
							}}
							onPress={() => onReasonPress(reason.value)}
							accessibilityRole="checkbox"
							accessibilityState={{ checked }}
							aria-checked={checked}
							title={reason.title}
							description={reason.description}
							left={({ style }) => (
								<Box
									style={[style, { marginLeft: 0, marginRight: 0 }]}
									alignItems="center"
									justifyContent="center"
									width={24}
									height={24}
								>
									<MaterialCommunityIcons
										name={
											reason.icon as React.ComponentProps<
												typeof MaterialCommunityIcons
											>["name"]
										}
										size={24}
										color={theme.colors.onSurface}
									/>
								</Box>
							)}
							right={({ style }) => (
								<Box style={style}>
									<Checkbox
										status={checked ? "checked" : "unchecked"}
										onPress={() => onReasonPress(reason.value)}
									/>
								</Box>
							)}
						/>
						{index !== feedbackReasonList.length - 1 && <Divider />}
					</Box>
				);
			})}
		</Box>
	);
};
